<ng-template [ngIf]="modificaDocumentoForm">
	<div class="col-sm-12 coldx">
		<form [formGroup]="modificaDocumentoForm" *ngIf="modificaDocumentoForm" (ngSubmit)="update();">
			<div class="row">
				<div class="col-sm-4">
					<p>
						<label for="posizione">Posizione</label>
						<input class="form-control" name="posizione" value="{{data.documento.posizione}}" type="text"
							disabled>
					</p>
				</div>
				<div class="col-sm-8">
					<p>
						<label for="nomefile">Nome file</label> <input name="nomeFile" class="form-control"
							value="{{getNameFile(data.documento.nomeFile)}}" type="text" disabled>
					</p>
				</div>
			</div>
			<div class="row">
				<div ng-select-combo class="col-sm-6" formControlName="tipoVisibilitaDocumento" [label]="'Visibilità documento'" [required]="true"
						[options]="tipiVisibilitaDocumento" [optionSel]="data.documento.tipoVisibilitaDocumento"
						(onChangeSel)="data.documento.tipoVisibilitaDocumento = $event; modificaDocumentoForm.controls['tipoVisibilitaDocumento'].setValue($event); ">
				</div>
			</div>
			<div class="row">
				<div textInput [control]="modificaDocumentoForm.controls['titolo']" [mandatory]="true" class="col-sm-6"
					[labelInput]="'Titolo'" formControlName="titolo" [(ngModel)]="data.documento.titolo"></div>

				<div ng-select-combo class="col-sm-6" formControlName="tipoDocumento"
					[label]="'Tipologia'" [required]="true"
					[options]="tipiDocumento" [optionSel]="data.documento.tipoDocumento"
					(onChangeSel)="data.documento.tipoDocumento = $event;  modificaDocumentoForm.controls['tipoDocumento'].setValue($event);">
				</div>
        	</div>

			<div class="row">
				<div ng-select-combo class="col-sm-4" formControlName="provenienza"
					[label]="'Provenienza'" [required]="true" [disabled]="isCensimentoDocumenti"
					[options]="tipiProvenienza" [optionSel]="data.documento.provenienza"
					(onChangeSel)="data.documento.provenienza = $event; modificaDocumentoForm.controls['provenienza'].setValue($event);">
				</div>

				<div datePickerInput class="col-sm-3" [control]="modificaDocumentoForm.controls['dataRiferimento']"
					[labelInput]="'Data riferimento'" formControlName="dataRiferimento" [mandatory]="true"
					[(ngModel)]="data.documento.dataRiferimento"></div>

				<div class="col-sm-3">
					<p>
						<label for="dataCaricamento">Data caricamento</label> <input name="dataCaricamento"
							class="form-control" value="{{data.documento.dataCaricamento | date:'dd/MM/yyyy'}}"
							type="text" disabled>
					</p>
				</div>

				<div class="col-sm-2">
					<p>
						<label for="versione">Numero versione</label> <input name="versione" class="form-control"
							value="{{data.documento.versione}}" type="text" disabled>
					</p>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-4">
					<p>
						<label for="autoredoc">Autore</label> <input name="autore" class="form-control"
							value="{{data.documento.autore}}" type="text" disabled>
					</p>
				</div>
				<div class="col-sm-4">
					<p>
						<label for="utenteAggiornamento">Utente ultima modifica</label> <input
							name="utenteAggiornamento" class="form-control"
							value="{{data.documento.utenteAggiornamento}}" type="text" disabled>
					</p>
				</div>
				<div class="col-sm-4">
					<p>
						<label for="dataAggiornamento">Data ultima modifica</label> <input name="dataAggiornamento"
							class="form-control" value="{{data.documento.dataAggiornamento  | date:'dd/MM/yyyy'}}"
							type="text" disabled>
					</p>
				</div>
			</div>
			<div class="row">
				<div textAreaInput class="col-sm-12" [labelInput]="'Note'" formControlName="note"
					[(ngModel)]="data.documento.note"></div>
			</div>
			<div class="row">
				<app-metadato-documento-form #metadatoDocumentoForm [documento]="data.documento"  [disabled]="readonlyMode" [isProtocol]="isProtocol" (onFormDataChanges)="onFormMetadataChanges($event)"></app-metadato-documento-form>
			</div>
			<div class="row container_fieldset" *ngIf="data.documento?.numeroProtocollo || data.documento?.oggettoProtocollo || data.documento?.dataProtocollazione">
				<div class="col-sm-12">
					<fieldset class="form-group">
						<legend>Dati Protocollazione</legend>
						<div class="row" style="margin: 0 0.5px 0 0.5px;">
							<div class="col-sm-4">
								<p>
									<label for="numeroProtocollo">Numero protocollo</label> <input name="numeroProtocollo" class="form-control"
										value="{{data.documento.numeroProtocollo}}" type="text" disabled>
								</p>
							</div>
							<div class="col-sm-4">
								<p>
									<label for="utenteProtocollatore">Utente protocollatore</label> <input name="utenteProtocollatore" class="form-control"
										value="{{data.documento.utenteProtocollatore}}" type="text" disabled>
								</p>
							</div>
							<div class="col-sm-4">
								<p>
									<label for="dataProtocollazione">Data protocollazione</label> <input name="dataProtocollazione"
										class="form-control" value="{{data.documento.dataProtocollazione | date:'dd/MM/yyyy'}}"
										type="text" disabled>
								</p>
							</div>
							<div class="col-sm-4">
								<p>
									<label for="inUscita">Registrazione</label> <input name="inUscita" class="form-control"
										value="{{ data.documento.inUscita ? 'IN USCITA' : 'IN ENTRATA' }}" type="text" disabled>
								</p>
							</div>
							<div class="col-sm-8">
								<p>
									<label for="senderReceiver">Mittente / Destinatario</label> <input name="senderReceiver" class="form-control"
										value="{{data.documento.senderReceiver}}" type="text" disabled>
								</p>
							</div>
						</div>
						<!-- Campo solo lettura -->
						<div class="row" style="margin: 0 0.5px 0 0.5px;">
							<div class="col-sm-12">
								<p>
									<label for="oggettoProtocollo">Oggetto</label> <input name="oggettoProtocollo" class="form-control"
										value="{{data.documento.oggettoProtocollo}}" type="text" disabled>
								</p>
							</div>
						</div>

						<!-- Campo modificabile -->
						<div class="row" style="margin: 0 0.5px 0 0.5px;">
							<div textAreaInput class="col-sm-12" [labelInput]="'Oggetto protocollo esteso'" formControlName="oggettoProtocolloEsteso"
								[(ngModel)]="data.documento.oggettoProtocolloEsteso"></div>
						</div>
					</fieldset>
				</div>
			</div>
			<!-- PROTOCOLLO ANNULLATO -->
			<ng-template [ngIf]="data.documento?.statoDocumento === 'ANNULLATO' && data?.documento?.flagAllegatoPrincipale">
				<div class="row container_fieldset">
					<div class="col-sm-12">
						<fieldset class="form-group">
						<legend>Campi protocollo annullato</legend>
						<div textInput [control]="modificaDocumentoForm.controls['estremiProvvedimento']" class="col-sm-4" [(ngModel)]="data.documento.estremiProvvedimento"
							[labelInput]="'Estremi del provvedimento di autorizzazione'" formControlName="estremiProvvedimento" [mandatory]="true"></div>

						<div datePickerInput class="col-sm-4" [labelInput]="'Data di annullamento'" formControlName="dataAnnullamento"
								[control]="modificaDocumentoForm.controls['dataAnnullamento']" [(ngModel)]="data.documento.dataAnnullamento"
								[mandatory]="true">
						</div>
						<div class="col-sm-4">
							<p>
								<label for="identificativoOperatore">Identificativo operatore</label> <input
									name="identificativoOperatore" class="form-control"
									value="{{data.documento.identificativoOperatore}}" type="text" disabled>
							</p>
						</div>
						</fieldset>
					</div>
				</div>
			</ng-template>

			<div class="row">
				<p class="col-sm-12 mandatory"><em>* Campi obbligatori</em></p>
			</div>
			<div class="row">
				<p class="col-sm-3 col-xs-6">
					<button type="button" class="btn btn-outline-secondary btn-block"
						(click)="resetForm();">Reset</button>
				</p>
				<p submitButton [disabled]="!modificaDocumentoForm.valid"
					class="col-sm-3 col-xs-6 col-sm-offset-6" [labelButton]="'Salva'"></p>
			</div>
		</form>
	</div>
</ng-template>
<!-- </div> -->

